module.exports = __webpack_public_path__ + "static/media/netresto-3.df2d984c.png";